import React, { forwardRef } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { cn } from '../../utils/cn';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'amber' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  href?: string;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'lg',
  href,
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-teal-700 text-white hover:bg-teal-800 focus:ring-teal-700',
    secondary: 'bg-stone-100 text-teal-900 hover:bg-stone-200 focus:ring-stone-200',
    amber: 'bg-amber-500 text-white hover:bg-amber-600 focus:ring-amber-500 shadow-lg shadow-amber-500/30',
    outline: 'border-2 border-teal-700 text-teal-700 hover:bg-teal-700 hover:text-white focus:ring-teal-700'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const classes = cn(baseStyles, variants[variant], sizes[size], className);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (variant === 'amber' && typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
    if (href) {
      e.preventDefault();
      if (href.startsWith('#')) {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      } else {
        window.location.href = href;
      }
    }
    props.onClick?.(e);
  };
  return <motion.button ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} onClick={handleClick} {...props} data-id="element-294">
        {children}
      </motion.button>;
});
Button.displayName = 'Button';